module.exports = __webpack_public_path__ + "static/media/deploy-to-netlify.4fdff352.svg";